<button
  data-test-id="button"
  [class]="buttonClass()"
  [type]="type()"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel() || null"
  (click)="onClick()"
>
  @if (label()) {
    {{ label() }}
  } @else {
    <ng-content />
  }
</button>
